import { type ExternalLinkData, isDefined } from '@terros/common'

export function sortExternalLinks(links: ExternalLinkData[]): ExternalLinkData[] {
  return links.sort((a, b) => {
    if (isDefined(a.order) && isDefined(b.order)) {
      return a.order - b.order
    }
    if (isDefined(a.order)) return -1
    if (isDefined(b.order)) return 1
    return a.label.localeCompare(b.label)
  })
}
